import { HcPortalEnv } from '@/features/auth/auth.def.ts'

const env = import.meta.env.VITE_HC_PORTAL_ENV as HcPortalEnv
const isDevelopment = env !== HcPortalEnv.Prod

export const AppEnv = {
  env,
  isDevelopment,
  features: {
    employeeProfile: true,
    departmentConfig: isDevelopment,
    teamConfig: true,
    onboarding: true,
    offboarding: true,
    overtime: isDevelopment,
    probation: true,
    promotion: true,
  },
}
